module.exports = __webpack_public_path__ + "static/media/pcc_sign_in_button_pressed_state.d0dc683b.svg";